import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { string, ref } from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons  
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";

import EmptyImage from "../../Assets/empty-image.png";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_LEVEL_SECTION } from "../../Schema/LevelSection";


export default function CreateSection({ open, handleClose, setRefetch }) {
  
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createLevelSection] = useMutation(CREATE_LEVEL_SECTION, {
    onCompleted: ({ createLevelSection }) => {
      setLoading(false);
      if (createLevelSection?.status) {
        setAlert(true, "success", createLevelSection?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createLevelSection?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    levelSectionKhName: Yup.string().required("require!"),
    levelSectionEnName: Yup.string().required("require!"),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
        levelSectionKhName: "",
        levelSectionEnName: "",
        remark: "",
    },
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("values:::", values);
      setLoading(true);
      createLevelSection({
        variables: {
          input: {
            ...values,
          },
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              បង្កើតកម្រិតនៃផ្នែក
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={6}>
                <Typography className="field-title">កម្រិតនៃផ្នែកជាខ្មែរ</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="ផ្នែកជាខ្មែរ"
                  {...getFieldProps("levelSectionKhName")}
                  error={Boolean(touched.levelSectionKhName && errors.levelSectionKhName)}
                  helperText={touched.levelSectionKhName && errors.levelSectionKhName}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography className="field-title">កម្រិតនៃផ្នែកជាអង់គ្លេស</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="ផ្នែកជាអង់គ្លេស"
                  {...getFieldProps("levelSectionEnName")}
                  error={Boolean(touched.levelSectionEnName && errors.levelSectionEnName)}
                  helperText={touched.levelSectionEnName && errors.levelSectionEnName}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">Remark</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>



              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    បង្កើត
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
